export const initialAuthState = (): AuthState => ({
  token: {
    access_token: '',
  },
  profile: {
    sub: '',
    exp: 0,
    iat: 0,
  },
  authenticated: false,
  pathname: '/',
  kibana: {
    token: {
      key: '',
      exp: 0,
      space: '',
      sub: 0,
      timestamp: '',
    },
    dashboards: [],
  },
});
